import { Trans } from "@lingui/react/macro"
import { IconCopy, IconFileDescription } from "@tabler/icons-react"
import { EditableAnalysisField } from "../../../EditableAnalysisField"
import classes from "../../styles.module.css"
import type { IProps } from "./interfaces"

/**
 * SummaryCard renders the meeting analysis summary with a "Copy" CTA in the
 * card header. When `editContext` is supplied the body becomes click-to-edit
 * and version history popups are wired automatically by EditableAnalysisField.
 */
export function SummaryCard({ text, onCopy, editContext }: IProps): React.JSX.Element {
  return (
    <section className={classes.card}>
      <div className={classes.cardHead}>
        <h2 className={classes.cardTitle}>
          <IconFileDescription size={16} />
          <Trans>Summary</Trans>
        </h2>
        <button type="button" className={classes.cardHcta} onClick={onCopy}>
          <IconCopy size={13} />
          <Trans>Copy</Trans>
        </button>
      </div>
      {text ? (
        editContext ? (
          <p className={classes.summaryText}>
            <EditableAnalysisField
              meetingId={editContext.meetingId}
              fieldPath="summary"
              value={text}
              canEdit={editContext.canEdit}
              isEdited={!!editContext.fieldEdits.summary}
              onSaved={editContext.onEdited}
            />
          </p>
        ) : (
          <p className={classes.summaryText}>{text}</p>
        )
      ) : (
        <p className={classes.empty}>
          <Trans>No summary yet.</Trans>
        </p>
      )}
    </section>
  )
}
